export const LOCAL_STORAGE_WELCOME_TOKEN_KEY = "welcomeToken"
